import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaUndo } from 'react-icons/fa';
import messages from './trainingMessages';

import DelayedDateRangePicker from '@/shared/components/input/DelayedDateRangePicker';
import PeriodButtonGroup from '@/shared/components/PeriodButtonGroup';
import UserSearch from '@/shared/components/input/UserSearch';
import TrainingStatusButtonGroup from '@/shared/components/TrainingStatusButtonGroup';
import intlShape from '@/shared/utils/intlShape';
import isEqual from 'lodash.isequal';

export const defaultFilters = {
  dateFrom: moment.utc().startOf('year'),
  dateUntil: moment.utc().endOf('year'),
  period: 'year',
  trainingStatuses: [],
};

class TrainingOverviewFilters extends Component {
  static propTypes = {
    filters: PropTypes.shape({
      dateFrom: momentPropTypes.momentObj,
      dateUntil: momentPropTypes.momentObj,
      trainingStatuses: PropTypes.arrayOf(PropTypes.number),
    }),
    onFilterChange: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    filters: defaultFilters,
  };

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const updated = { ...filters, ...filter };

    if (JSON.stringify(filters) !== JSON.stringify(updated)) {
      onFilterChange(updated);
    }
  };

  hasActiveFilters = () => {
    const { filters } = this.props;

    const dateFromChanged =
      !!filters.dateFrom && !!defaultFilters.dateFrom
        ? !filters.dateFrom.isSame(defaultFilters.dateFrom, 'day')
        : filters.dateFrom !== defaultFilters.dateFrom;

    const dateUntilChanged =
      !!filters.dateUntil && !!defaultFilters.dateUntil
        ? !filters.dateUntil.isSame(defaultFilters.dateUntil, 'day')
        : filters.dateUntil !== defaultFilters.dateUntil;

    return (
      dateFromChanged ||
      dateUntilChanged ||
      filters.period !== defaultFilters.period ||
      !isEqual(filters.trainingStatuses, defaultFilters.trainingStatuses)
    );
  };

  resetFilters = () => {
    this.filterChanged({ ...defaultFilters });
  };

  dateChanged = (dateFrom, dateUntil) => {
    this.filterChanged({ dateFrom, dateUntil });
  };

  render() {
    const { filters, intl } = this.props;

    return (
      <div className="training-overview-filters">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <DelayedDateRangePicker
                startDate={filters.dateFrom}
                startDateId="TrainingOverviewDateFrom"
                endDate={filters.dateUntil}
                endDateId="TrainingOverviewDateUntil"
                onDatesChange={({ startDate, endDate }) => this.dateChanged(startDate, endDate)}
                block
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group">
              <PeriodButtonGroup
                dateFrom={filters.dateFrom}
                dateUntil={filters.dateUntil}
                period={filters.period}
                onChange={this.filterChanged}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-sm-6">
            <div className="form-group">
              <TrainingStatusButtonGroup
                selectedStatuses={filters.trainingStatuses}
                onChange={value => {
                  this.filterChanged({ trainingStatuses: value });
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex-row">
          <div className="btn-group save-filters">
            {this.hasActiveFilters() && (
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={this.resetFilters}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TrainingOverviewFilters);
